import React from 'react'
import { useInterval } from 'react-nb-hooks'

function tickerReducer(seconds) {
  return seconds - 1
}

export function useTicker(timeout) {
  const [secondsLeft, tick] = React.useReducer(tickerReducer, timeout)

  useInterval(tick, secondsLeft > 0 ? 1000 : null)

  return secondsLeft
}

export const useCallbackInstance = (handler) => {
  const callbackRef = React.useRef(handler)

  React.useEffect(() => {
    callbackRef.current = handler
  }, [handler])

  return React.useCallback((...args) => {
    callbackRef.current(...args)
  }, [])
}

export const useConstant = (fn) => {
  const ref = React.useRef()

  if (!ref.current) {
    ref.current = { v: fn() }
  }

  return ref.current.v
}
